module.exports = __webpack_public_path__ + "static/about-lsh-kids-42a97a2f898763747dc997073c08e164.jpg";